import { render, staticRenderFns } from "./ImportedQuestionsComponent.vue?vue&type=template&id=385fc520&scoped=true&"
import script from "./ImportedQuestionsComponent.vue?vue&type=script&lang=js&"
export * from "./ImportedQuestionsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ImportedQuestionsComponent.vue?vue&type=style&index=0&id=385fc520&prod&scoped=true&lang=css&"
import style1 from "./ImportedQuestionsComponent.vue?vue&type=style&index=1&id=385fc520&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385fc520",
  null
  
)

export default component.exports